export const initialsFromName = (value: string) => {
  const parts = value.split(" ").filter(Boolean);
  const first = parts[0]?.[0] ?? "";
  const last = parts.length > 1 ? parts[parts.length - 1]?.[0] ?? "" : "";
  return `${first}${last}`.toUpperCase() || "FN";
};

export type AssignmentFilter = "all" | "unassigned";
export type SortFilter =
  | "newest"
  | "oldest"
  | "firstNameAsc"
  | "firstNameDesc"
  | "lastNameAsc"
  | "lastNameDesc";

export const SORT_OPTIONS: { value: SortFilter; label: string }[] = [
  { value: "newest", label: "Newest First" },
  { value: "oldest", label: "Oldest First" },
  { value: "firstNameAsc", label: "First Name A-Z" },
  { value: "firstNameDesc", label: "First Name Z-A" },
  { value: "lastNameAsc", label: "Last Name A-Z" },
  { value: "lastNameDesc", label: "Last Name Z-A" }
];

export const sortLabel = (filter: SortFilter) =>
  SORT_OPTIONS.find((o) => o.value === filter)?.label ?? "Newest First";

export type ClientColumnId =
  | "firm"
  | "citizenship"
  | "status"
  | "deadline"
  | "workflows"
  | "portal"
  | "assignment";

export const CLIENT_COLUMNS: { id: ClientColumnId; label: string }[] = [
  { id: "firm", label: "Law Firm" },
  { id: "citizenship", label: "Citizenship" },
  { id: "status", label: "Status" },
  { id: "deadline", label: "Next Deadline" },
  { id: "workflows", label: "Workflows" },
  { id: "portal", label: "Portal" },
  { id: "assignment", label: "Team" }
];

/**
 * The columns Display shows. Status and Next Deadline stay hidden while no
 * loaded client has a value; a choice made in Display wins either way.
 */
export const visibleClientColumns = ({
  overrides,
  isSuperAdmin,
  anyStatus,
  anyDeadline
}: {
  overrides: Partial<Record<ClientColumnId, boolean>>;
  isSuperAdmin: boolean;
  anyStatus: boolean;
  anyDeadline: boolean;
}): Set<ClientColumnId> => {
  const defaults: Record<ClientColumnId, boolean> = {
    firm: isSuperAdmin,
    citizenship: true,
    status: anyStatus,
    deadline: anyDeadline,
    workflows: true,
    portal: true,
    assignment: true
  };
  return new Set(
    CLIENT_COLUMNS.map((c) => c.id).filter(
      (id) => overrides[id] ?? defaults[id]
    )
  );
};

export const assignmentPillLabel = (
  assignmentFilter: AssignmentFilter,
  assignedUserUidFilter: string,
  members: { uid?: string; label: string }[]
) => {
  const uid = assignedUserUidFilter.trim();
  if (uid) {
    const member = members.find((m) => (m.uid ?? "").trim() === uid);
    return member?.label ?? "—";
  }
  switch (assignmentFilter) {
    case "unassigned":
      return "Unassigned";
    case "all":
    default:
      return "All Profiles";
  }
};
